import React from "react";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  fixedHeightPaper: {
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.secondary,
    height: 260
  }
}));

export const Card = ({ children }) => {
  const classes = useStyles();
  return <Paper className={classes.fixedHeightPaper}>{children}</Paper>;
};
